// @ts-nocheck

// @index('./*.vue', (f, _) => `import { default as BookOrder${_.pascal(f.name)} } from '${f.path}${f.ext}'`)
import { default as BookOrderActions } from './actions.vue'
// @endindex

export const BookOrderComponents = {
  // @index('./*.vue', (f, _) => `BookOrder${_.pascal(f.name)},`)
  BookOrderActions,
  // @endindex
}
